import { render, staticRenderFns } from "./FieldNumber.vue?vue&type=template&id=049cc478&scoped=true"
import script from "./FieldNumber.vue?vue&type=script&lang=js"
export * from "./FieldNumber.vue?vue&type=script&lang=js"
import style0 from "./FieldNumber.vue?vue&type=style&index=0&id=049cc478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049cc478",
  null
  
)

export default component.exports